import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase, Void } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { GetRegisteredClientsCountResponse } from './get-registered-clients-count.response';

@Injectable({ providedIn: 'root' })
export class GetRegisteredClientsCountUseCase extends UseCase<Void, Observable<GetRegisteredClientsCountResponse>> {
    private _apiRequestService = inject(ApiRequestService);
    private _authBaseUrl = inject<string>('AUTH_BACKEND_URL' as never);
    private _getRegisteredClientsCountUrl = '/getRegisteredClientsCount';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(): Observable<GetRegisteredClientsCountResponse> | void {
        return this._apiRequestService.sendRequest<object, GetRegisteredClientsCountResponse>(
            this._authBaseUrl,
            {},
            true,
            this._getRegisteredClientsCountUrl
        );
    }
}
